<!-- 积分商城 -->
<template>
  <div style="height:100%">
    <van-tabs @click="check_tab">
      <!-- <van-tab title="优惠券"  name="coupons"></van-tab> -->
      <van-tab title="积分商城" name="integral"></van-tab>
      <van-tab title="待核销"  name="writeOff"></van-tab>
      <van-tab title="已核销"  name="writeOn"></van-tab>
      <van-tab title="已失效"  name="lostt"></van-tab>
    </van-tabs>
    <div class="body" :is='active'></div>
    <!-- <van-action-sheet v-model="ifshow" :actions="actions" cancel-text="取消" close-on-click-action/> -->

    <!-- 引入子组件 -->
    <!-- <recodes ref="recodes"/> -->
  </div>
</template>

<style lang="scss" scoped>
  .inte_title {
    font-size:15px;
    line-height:44px;
    padding-left:20px;
    background:#fff;
  }

  .body {
    border: 0;
    height: calc(100vh - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    background: #eee;
  }

  .van-cell__title {
    font-size: 15px;
  }

  .num {
    font-size: 18px;
  }
</style>

<script>
import coupons from './coupon'
import integral from './integral'
import writeOff from './write_off'
import writeOn from './write_on'
import recodes from './records'
import lostt from './lostt'

export default {
  name: 'inte_store',
  components: {coupons, integral, writeOff, writeOn, recodes, lostt},
  data () {
    return {
      data: [],
      active: 'integral',
      ifshow: false,
      actions: [{type: 'recodes', name: '兑换记录'}]
    }
  },
  methods: {
    my_mounted () {
      this.$root.loadingAll = false
    },

    // 切换
    check_tab (val) {
      this.active = val
    }

    // 点击选择
    // select (val) {
    //   if (val.type === 'recodes') {
    //     this.$refs.recodes.show()
    //     this.ifshow = true
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inte_store/inte_store.vue